import ReactMarkdown from "react-markdown";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { TiArrowLeftThick } from 'react-icons/ti'
// @ts-expect-error - Vite handles this import via assetsInclude
import markdownUrl from "./my-keeb.md";

export const Route = createFileRoute('/my-keeb')({
  component: MyKeeb,
})

function MyKeeb() {
  const [content, setContent] = useState("");

  useEffect(() => {
    fetch(markdownUrl)
      .then((res) => res.text())
      .then((text) => setContent(text));
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="bg-white p-8 rounded-lg shadow-md">
        <div className="mb-8">
          <a href="/" className="text-blue-600 hover:text-blue-800 flex items-center gap-2">
            <TiArrowLeftThick /> Home
          </a>
        </div>

        <ReactMarkdown
          components={{
            h1: ({ node, ...props }) => (
              <h1 className="text-2xl font-bold text-black mb-4" {...props} />
            ),
            h2: ({ node, ...props }) => (
              <h2
                className="text-xl font-bold text-black mt-6 mb-3"
                {...props}
              />
            ),
            h3: ({ node, ...props }) => (
              <h3
                className="text-lg font-bold text-black mt-4 mb-2"
                {...props}
              />
            ),
            p: ({ node, ...props }) => (
              <p className="text-black mb-4 leading-relaxed" {...props} />
            ),
            ul: ({ node, ...props }) => (
              <ul
                className="list-disc list-inside space-y-2 ml-4 mb-4 text-black"
                {...props}
              />
            ),
            li: ({ node, ...props }) => (
              <li className="text-black" {...props} />
            ),
            code: ({ node, ...props }) => (
              <code
                className="bg-gray-100 px-1 py-0.5 rounded text-sm font-mono text-black"
                {...props}
              />
            ),
            img: ({ node, ...props }) => (
              <img
                className="rounded-lg shadow-sm max-w-full h-auto my-6"
                {...props}
              />
            ),
          }}
        >
          {content}
        </ReactMarkdown>
      </div>
    </div>
  );
}
